import React, { useState, useMemo } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import { MenuHeader } from './components/MenuHeader';
import { HeroSection } from './components/HeroSection';
import { CategoryFilter } from './components/CategoryFilter';
import { MenuGrid } from './components/MenuGrid';
import { CartSheet } from './components/CartSheet';
import { Toaster } from './components/ui/sonner';
import { categories } from './data/menuData';
import { useApp } from './contexts/AppContext';

const MenuPage = () => {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const { language } = useApp();

  const filteredCategories = useMemo(() => {
    const queryLower = query.toLowerCase();
    
    return categories
      .map((category) => {
        const categoryTitle = category.title[language];
        const categoryTitleLower = categoryTitle.toLowerCase();
        
        const filteredItems = category.items.filter((item) => {
          // Check category filter
          const matchesCategory = activeCategory === 'all' || category.id === activeCategory;
          if (!matchesCategory) return false;
          
          // Get localized item name
          const itemName = typeof item.name === 'string' ? item.name : item.name[language];
          
          // Get localized description (if exists)
          let itemDesc = '';
          if (item.desc) {
            itemDesc = typeof item.desc === 'string' ? item.desc : item.desc[language];
          }
          
          // Check search query match
          const matchesQuery =
            itemName.toLowerCase().includes(queryLower) ||
            categoryTitleLower.includes(queryLower) ||
            itemDesc.toLowerCase().includes(queryLower);
          
          return matchesQuery;
        });
        
        return { ...category, items: filteredItems };
      })
      .filter((category) => category.items.length > 0);
  }, [activeCategory, query, language]);

  return (
    <div className="min-h-screen bg-background">
      <MenuHeader />
      <HeroSection query={query} setQuery={setQuery} />
      <CategoryFilter activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
      <MenuGrid filteredCategories={filteredCategories} />
      <CartSheet />
      <Toaster position="top-center" />
    </div>
  );
};

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MenuPage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;